import {
  AppBar,
  Box,
  Chip,
  Grid,
  Paper,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material'
import React, { createContext, useContext, useState } from 'react'
import { TenantSettingsContext } from '../../../../App'
import ClientPortalMenu from './Menu'
import { ClientPortalContext } from '../ClientPortal'
import { useNavigate } from 'react-router-dom'

const ClientPortalTopBar = () => {
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig
  const { organisation } = useContext(ClientPortalContext)

  return (
    <Grid item xs={12}>
      <Box component={Paper} padding={{ xs: 1, lg: 3 }} borderRadius={2}>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={8} order={{ xs: 2, lg: 1 }}>
            <Stack gap={1} height="100%" justifyContent="center">
              <Typography
                variant="title2"
                fontSize="1.4rem"
                sx={{ color: 'primary.main' }}
              >
                {orgSettings?.orgName}
              </Typography>
              <Typography variant="title3">Organiser Portal</Typography>
              <Chip
                label={organisation?.orgName}
                color="anMainBlue"
                sx={{ borderRadius: 1 }}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} lg={4} order={{ xs: 1, lg: 2 }}>
            <Stack
              height="100%"
              width="100%"
              bgcolor={orgSettings?.logobackgroundColor}
              alignItems="center"
              justifyContent="center"
              borderRadius={2}
            >
              <Box
                component="img"
                padding={orgSettings?.logobackgroundColor ? 1 : 0}
                src={orgSettings?.logo}
                maxWidth="80%"
                maxHeight="100px"
                sx={{ objectFit: 'contain' }}
              />
            </Stack>
          </Grid>
          <ClientPortalMenu />
        </Grid>
      </Box>
    </Grid>
  )
}

export default ClientPortalTopBar
